import { Filter, IActiveFilters } from 'api-paths-cas';
import { CheckRadioGroupInfo } from '../../../../../types';
import { Box, Checkbox, CheckboxGroup } from '@chakra-ui/react';
import { useState } from 'react';

export interface IProps {
  filter: Filter;
  list: CheckRadioGroupInfo[];
  activeFilters: IActiveFilters;
}

export interface IDispatchProps {
  saveFilter: (filterKey: string, values: string[]) => void;
}

export const SelectMany = ({ filter, list, saveFilter }: IProps & IDispatchProps): JSX.Element => {
  const checkedOptions = list.filter(item => item.checked);
  // in insights/next-upgrade, the checked option values do not update automatically on the font-end with
  // saveFilter due to an architecture difference with the old insights (no Redux I think?)
  // Changing this value to a state restores all functionality.
  // - Ryan
  const [checkedOptionValues, setCheckedOptionValues] = useState(checkedOptions.map(item => item.value)); // Modified: Changed to state - Ryan

  const onChange = (selectedValues: string[]): void => {
    setCheckedOptionValues(selectedValues); // Modified: Added line, updates state when checkbox selected - Ryan
    saveFilter(filter.key, selectedValues);
  };

  return (
    <Box data-selector="checkbox-group">
      <CheckboxGroup onChange={onChange} value={checkedOptionValues}>
        {list.map(item => {
          return (
            <Checkbox
              key={item.value}
              value={item.value}
              data-selector={item.label}
              aria-checked={item.checked}
              variant="ghost"
              mb={0.5}
            >
              {item.label}
            </Checkbox>
          );
        })}
      </CheckboxGroup>
    </Box>
  );
};
